<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>İletişime Geçin</h2>
            <ul>
                <li><a routerLink="/">Anasayfa </a></li>
                <li class="active">İletişime Geçin</li>
            </ul>
        </div>
    </div>

    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div>
</div>

<section class="contact-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="single-contact">
                    <div class="icon">
                        <i class='bx bx-envelope'></i>
                    </div>

                    <div class="content">
                        <h3>E-Posta</h3>
                        <p *ngIf="mail">{{mail.value}}</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-contact">
                    <div class="icon">
                        <i class='bx bx-location-plus'></i>
                    </div>

                    <div class="content">
                        <h3>Adres</h3>
                        <p *ngIf="adres">{{adres.value}}</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-12">
                <div class="single-contact">
                    <div class="icon">
                        <i class='bx bx-phone-call'></i>
                    </div>

                    <div class="content">
                        <h3>Telefon</h3>
                        <p *ngIf="tel">{{tel.value}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="home-contact-area home-2-contact pb-100">
    <div class="container">
        <div class="section-title">
            <!-- <span>Contact Us</span> -->
            <h2>Bize mesaj gönderin</h2>
            <!-- <p>It is a long established fact that a reader will be distracted by the rea dable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more.</p> -->
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="content">
                    <form [formGroup]="contactForm" id="contactForm" (ngSubmit)="sendContact()">
                        <div class="row">
                            <div class="col-lg-12 col-sm-12">
                                <div class="row form-group">
                                    <div class="col-lg-6 col-sm-6 float-left">
                                        <input type="text" name="firstName" id="firstName" class="form-control"
                                            formControlName="firstName" required placeholder="Adınız" />
                                    </div>

                                    <div class="col-lg-6 col-sm-6 float-left">
                                        <input type="text" name="lastName" id="lastName" class="form-control"
                                            formControlName="lastName" required placeholder="Soyadınız" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="email" name="email" id="email" class="form-control"
                                        formControlName="email" required placeholder="E-Posta Adresiniz" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <input type="text" name="subject" id="subject" class="form-control"
                                        formControlName="subject" required placeholder="Konu" />
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea name="message" class="form-control" id="message" formControlName="message"
                                        cols="30" rows="5" required placeholder="Mesajınız"></textarea>
                                </div>
                            </div>

                            <div class="col-lg-6 col-sm-6 float-left">
                                <div class="form-group">
                                    <re-captcha
                                      siteKey="6LfzGCIkAAAAAJ0UIDIpnDqwckbJbxVLhdls2mtX"
                                      formControlName="recaptcha"
                                    ></re-captcha>
                                  </div>
                            </div>

                            <div class="col-lg-6 col-sm-6 float-left" style="margin: auto;">
                                <button type="submit" class="default-btn page-btn box-btn">Gönder</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="contact-img contact-img-2">
                    <img src="assets/images/contact-img2.jpg" alt="contact" />
                </div>
            </div>
        </div>
    </div>
</section>